import { render } from "./CombatImplants.vue?vue&type=template&id=485acf17&scoped=true"
import script from "./CombatImplants.vue?vue&type=script&lang=js"
export * from "./CombatImplants.vue?vue&type=script&lang=js"

import "./CombatImplants.vue?vue&type=style&index=0&id=485acf17&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-485acf17"]])

export default __exports__